var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('back-home-button'),_c('h1',[_vm._v("sobre o spira")]),_c('main',[_c('p',[_vm._v("Texto descritivo sobre o projeto SPIRA")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }